import { render, staticRenderFns } from "./VideoCourse.vue?vue&type=template&id=36e8e7f2&scoped=true&"
import script from "./VideoCourse.vue?vue&type=script&lang=js&"
export * from "./VideoCourse.vue?vue&type=script&lang=js&"
import style0 from "./VideoCourse.vue?vue&type=style&index=0&id=36e8e7f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8e7f2",
  null
  
)

export default component.exports